import React from "react";
import Sidebar from "../../components/Sidebar";
import CampaignsTable from "./components/CampaignsTable";

const CouponCampaigns = () => {
  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      <Sidebar />

      <div className="overflow-y-auto flex-1 p-4 bg-white md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-6">Coupon Campaigns</h1>

        <div className="">
          <CampaignsTable />
        </div>
      </div>
    </div>
  );
};

export default CouponCampaigns;
